/**
 * Farbrollen aus dem Markenhandbuch (brand-guidelines.md, "Rollen" und "Alert").
 * Vorlaeufige Werte, gelten bis zur Abloesung. Im Code immer die Rolle verwenden,
 * nie den Hexwert direkt. Neue Rollen zuerst im Handbuch ergaenzen.
 */
const brandRoles = {
  linkText: '#2E5633',
  linkHover: '#1E322B',

  knopfHellFlaeche: '#DDEDD6',
  knopfHellRand: '#5A853D',
  knopfHellText: '#2E5633',
  knopfHellHoverFlaeche: '#2E5633',
  knopfHellHoverText: '#FFFFFF',

  knopfVollFlaeche: '#426E37',
  knopfVollText: '#FFFFFF',
  // Card-Flaeche (Komponente "Project Card": Flaeche weiss)
  flaecheWeiss: '#FFFFFF',

  // Neutrale Stufen (Design-Tokens --cp-neutral-*)
  neutral50: '#FAFAFA',
  neutral100: '#F5F5F5',
  neutral200: '#E9EAEB',
  neutral300: '#D5D7DA',
  neutral400: '#A4A7AE',
  neutral800: '#181D27',
  neutral700: '#414651',
  neutral500: '#717680',

  // Rollen "randDezent" und Erfolgsflaeche fuer Zaehler-Etiketten
  randDezent: '#C3DCB2',

  // Tag (Komponente "Tag", hell)
  tagHellFlaeche: '#DDEDD6',
  tagHellText: '#2E5633',

  hinweisFlaeche: '#F5F5F5',
  hinweisRand: '#D5D7DA',
  hinweisSymbol: '#414651',
  hinweisText: '#181D27',

  erfolgFlaeche: '#EEF6ED',
  erfolgRand: '#AAC889',
  erfolgSymbol: '#5A853D',
  erfolgText: '#2E5633',

  warnungFlaeche: '#FFF5DC',
  warnungRand: '#EBC873',
  warnungSymbol: '#A86A0C',
  warnungText: '#6E4708',

  fehlerFlaeche: '#FDF0EE',
  fehlerRand: '#EDB2A8',
  fehlerSymbol: '#B8402D',
  fehlerText: '#8C2A1C',
};

export default brandRoles;
